import { createApi } from "../axiosInstance";
import { createSalesApi } from "../shared/salesApiFactory";

const api = createApi("myFPO");

export const {
  getSalesQuotations,
  getSalesQuotationByVendor,
  getSalesQuotationById,
  createSalesQuotation,
  updateSalesQuotation,
  deleteSalesQuotation,
  downloadQuotationReport,
  getSalesInvoices,
  getSalesInvoiceByVendor,
  getSalesInvoiceById,
  createSalesInvoice,
  updateSalesInvoice,
  UpdateDeliveryChallan,
  deleteSalesInvoice,
  downloadSalesInvoiceReport,
  getSalesReturns,
  getSalesReturnBySales,
  getSalesReturnById,
  createSalesReturn,
  updateSalesReturn,
  deleteSalesReturn,
  downloadDeliveryChallanReport,
  downloadSalesReturnReport,
  getSalesStockReport,
  getSalesReturnReport,
  getSalesOverallStock,
  downloadSalesOverallStockReport,
} = createSalesApi(api);
